import { useEffect, type RefObject } from 'react';

// On a slow connection the server-rendered form is usable seconds before its JavaScript takes
// over. What the person typed in that time is in the field but not in React's state, so Send
// stayed disabled and the next re-render wiped it (LANE-D-28). Once, right after hydration, adopt
// whatever is already in the field.
export function useAdoptEarlyInput(
  ref: RefObject<HTMLInputElement | HTMLTextAreaElement | null>,
  set: (value: string) => void,
): void {
  useEffect(() => {
    const typed = ref.current?.value;
    if (typed) set(typed);
    // Runs once, after hydration: later edits already go through onChange.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
